import { sumBy } from "lodash";
import { billingDashboardStyle } from "../style";
import CountGraph from "./CountGraph";

const TotalCharge = ({ data }) => {

    const classes = billingDashboardStyle();
    const totalCost = (sumBy(data, item => item.totalChargeToClient) ?? 0).toFixed(2);
    return (
        <CountGraph title='Total Charge' count={totalCost} />
    )
}

export default TotalCharge;